import { useCallback } from "react"
import { Block, Plus, Skeleton, useStyletron } from "@mezo-org/mezo-clay"

import { selectHasLoadedTransactions, useDappSelector } from "#/redux-state"
import { useStatistics, useTotalMezoWalletUSDValue } from "#/shared/hooks"
import { usePosthogButtonClickedEvent } from "#/shared/hooks/posthog-events"
import { PosthogAnalyticsId } from "#/shared/types"
import { separateThousandsWithComma } from "#/shared/utils"
import { BridgeAssetButton } from "#/ui/Button"
import AvailableTokens from "#/ui/Token/AvailableTokens"

import HomepageMainSectionAssetsItem from "./HomepageMainSectionAssetsItem"

export default function HomepageMainSectionAssetsDeposits() {
  const hasLoadedTransactions = useDappSelector(selectHasLoadedTransactions)

  const { totalWalletUSDValue } = useTotalMezoWalletUSDValue()
  const { emitButtonClickedEvent } = usePosthogButtonClickedEvent()

  const addFundsButtonHandler = useCallback(() => {
    emitButtonClickedEvent(PosthogAnalyticsId.ASSETS_ADD_FUNDS)
  }, [emitButtonClickedEvent])

  const [css, theme] = useStyletron()

  useStatistics()

  return (
    <HomepageMainSectionAssetsItem
      title="Total account value"
      isLoading={!hasLoadedTransactions}
      header={
        hasLoadedTransactions ? (
          <AvailableTokens tokensToDisplay="mezo-tokens" />
        ) : (
          <Skeleton
            animation
            width={theme.sizing.scale1600}
            height={theme.sizing.scale800}
          />
        )
      }
      value={
        <>
          ${" "}
          <Block
            data-attr="deposit_active"
            as="span"
            className={css({
              color: totalWalletUSDValue > 0 ? "black" : "#A6A6A6",
            })}
          >
            {separateThousandsWithComma(totalWalletUSDValue)}
          </Block>
        </>
      }
      label={<Block height={theme.sizing.scale700} />}
      buttons={[
        ...(hasLoadedTransactions
          ? [
              <BridgeAssetButton
                onClick={addFundsButtonHandler}
                size="small"
                shape="default"
                startEnhancer={<Plus color="white" size={16} />}
              />,
            ]
          : []),
      ]}
    />
  )
}
